module.exports = __webpack_public_path__ + "static/media/editNew.72013203.svg";